export default __webpack_public_path__ + "static/media/theater_profile.62988246.jpg";